/**
 * @fileoverview Navigation helpers for link-based flows.
 * Used to redirect users to Paytm or other URLs via full page navigation.
 */

export const NavigationHelpers = {
	/**
	 * Performs a full page redirect to the given URL.
	 * @param {string} url - Absolute or relative URL to navigate to.
	 * @returns {void}
	 */
	redirectToPaytm: url => {
		window.location = url;
	}
};
